import englishUi from "@/translations/en/quality-ui.json"
import { createTranslator, type useTranslations } from "next-intl"
import { getSERVICE_METRIC_POPULATION, getAI_HANDLED_POPULATION, getACTOR_LABELS, getCOHORT_LABELS, getCOHORT_DEFINITIONS, getATTRIBUTION_CAPTIONS, getSERVICE_METRIC_DEFINITIONS, getOUTCOME_METRIC_DEFINITIONS } from "@/lib/conversation-quality/metric-definitions"
import { getOUTCOME_LABELS, getOUTCOME_DEFINITIONS, getESCALATION_CATEGORY_LABELS, getTAKEOVER_REASON_LABELS, getTOPIC_CATEGORY_LABELS, getHUMAN_OUTCOME_LABELS, getHUMAN_OUTCOME_DEFINITIONS } from "@/lib/conversation-quality/outcome-display"

const englishUiTranslator = createTranslator({ locale: "en", messages: englishUi, namespace: "QualityUi" })

export type QualityCopy = ReturnType<typeof getQualityCopy>

export const defaultQualityCopy = getQualityCopy()

export function getQualityCopy(metrics?: ReturnType<typeof useTranslations<"QualityMetrics">>, outcomes?: ReturnType<typeof useTranslations<"QualityOutcomes">>, ui: ReturnType<typeof useTranslations<"QualityUi">> = englishUiTranslator) {
  return {
    ui,
    SERVICE_METRIC_POPULATION: getSERVICE_METRIC_POPULATION(metrics),
    AI_HANDLED_POPULATION: getAI_HANDLED_POPULATION(metrics),
    ACTOR_LABELS: getACTOR_LABELS(metrics),
    COHORT_LABELS: getCOHORT_LABELS(metrics),
    COHORT_DEFINITIONS: getCOHORT_DEFINITIONS(metrics),
    ATTRIBUTION_CAPTIONS: getATTRIBUTION_CAPTIONS(metrics),
    SERVICE_METRIC_DEFINITIONS: getSERVICE_METRIC_DEFINITIONS(metrics),
    OUTCOME_METRIC_DEFINITIONS: getOUTCOME_METRIC_DEFINITIONS(metrics),
    OUTCOME_LABELS: getOUTCOME_LABELS(outcomes),
    OUTCOME_DEFINITIONS: getOUTCOME_DEFINITIONS(outcomes),
    ESCALATION_CATEGORY_LABELS: getESCALATION_CATEGORY_LABELS(outcomes),
    TAKEOVER_REASON_LABELS: getTAKEOVER_REASON_LABELS(outcomes),
    TOPIC_CATEGORY_LABELS: getTOPIC_CATEGORY_LABELS(outcomes),
    HUMAN_OUTCOME_LABELS: getHUMAN_OUTCOME_LABELS(outcomes),
    HUMAN_OUTCOME_DEFINITIONS: getHUMAN_OUTCOME_DEFINITIONS(outcomes),
  }
}
